import { __assign } from "tslib";
import FlightsFilter from './components/FlightsFilter.css';
import WeekDaysSelector from './components/WeekDaysSelector/WeekDaysSelector.css';
import DateSelector from './components/DateSelector/DateSelector.css';
import DatePicker from './components/DatePicker/theme';
export default __assign({ FlightsFilter: FlightsFilter, WeekDaysSelector: WeekDaysSelector, DateSelector: DateSelector }, DatePicker);
